import React from "react";

const AboutSection = () => {
  return (
    <section className="about-section section-padding sect-bg">
      <div className="shape-1">
        <img src="/img/about/dot-shape.png" alt="shape" />
      </div>

      <div className="container">
        <div className="about-wrapper">
          <div className="row g-4 align-items-center">
            
            {/* Left Image */}
            <div className="col-lg-5">
              <div className="about-image wow img-custom-anim-left">
                <img src="/images/homeabout.png" alt="Royal Route Cab" />

                {/* <div className="about-box float-bob-y">
                  <h2>
                    <span className="odometer" data-count="10">00</span>+
                  </h2>
                  <p>YEARS OF EXPERIENCE</p>
                </div> */}
              </div>
            </div>

            {/* Right Content */}
            <div className="col-lg-7">
              <div className="about-content">
                
                {/* Title */}
                <div className="section-title">
                  <span className="wow fadeInUp">About Royal Route Cab</span>
                  <h2 className="wow fadeInUp text-dark" data-wow-delay=".3s">
                    Your Trusted Travel Partner for Safe & Comfortable Journeys
                  </h2>
                </div>

                {/* Paragraph 1 */}
                <p
                  className="wow fadeInUp mt-4 mt-md-0"
                  data-wow-delay=".5s"
                >
                  Royal Route Cab is a reliable and customer-focused cab service provider,
                  offering seamless travel experiences across Mumbai and beyond. With a strong
                  commitment to safety, punctuality, and comfort, we provide a wide range of
                  services including outstation trips, airport transfers, corporate travel,
                  and event transportation. Our well-maintained fleet and professional drivers
                  ensure every journey is smooth, secure, and stress-free.
                </p>

                {/* Paragraph 2 */}
                <p
                  className="wow fadeInUp mt-3"
                  data-wow-delay=".6s"
                >
                  Whether you're traveling for business or leisure, Royal Route Cab delivers
                  affordable and flexible travel solutions tailored to your needs. We pride
                  ourselves on transparent pricing, 24/7 availability, and exceptional customer
                  support. Our mission is to redefine cab services by combining quality,
                  reliability, and convenience — making every ride a premium experience.
                </p>

                {/* Highlight Quote */}
                <div
                  className="about-sideber wow fadeInUp"
                  data-wow-delay=".3s"
                >
                  <h5>
                    “At Royal Route Cab, we don’t just provide rides — we deliver comfort, trust, and a premium travel experience every time.”
                  </h5>
                </div>

                {/* Features */}
                {/* <div className="about-icon-items">

                  <ul className="wow fadeInUp" data-wow-delay=".3s">
                    <li>✔ Experienced & Professional Drivers</li>
                    <li>✔ 24x7 Reliable Cab Services</li>
                    <li>✔ Clean & Well-Maintained Vehicles</li>
                  </ul>

                  <ul className="wow fadeInUp" data-wow-delay=".5s">
                    <li>✔ Affordable & Transparent Pricing</li>
                    <li>✔ Easy Online & WhatsApp Booking</li>
                    <li>✔ Pan India Travel Coverage</li>
                  </ul>

                </div> */}

                {/* Button */}
              

              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;